import React from 'react'

const ErrorPage = () => {
  return (
    <div className='w-full h-[70vh] flex justify-center items-center'>
      <p className='text-2xl text-gray-600'>
       Url Not Found
      </p>
    </div>
  )
}

export default ErrorPage
